import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'ax.new-claim-report.summary.title',
        defaultMessage: 'New Claim Save:'
    },
    subTitle: {
        id: 'ax.new-claim-report.summary.subTitle',
        defaultMessage: 'The claim '
    },
    subTitle2: {
        id: 'ax.new-claim-report.summary.subTitleComplement',
        defaultMessage: ' is save'
    },
    errorMessage: {
        id: 'ax.new-claim-report.summary.error',
        defaultMessage: 'Please contact support'
    },
    creatingClaimLoadingMessage: {
        id: 'ax.new-claim-report.summary.loading-text',
        defaultMessage: 'Please wait... We are working on create your claim'
    }
});
